import React from 'react';
import { Form, Input, Button } from 'antd';
import { withTranslation } from "react-i18next"
import { EditOutlined , UserOutlined, PhoneOutlined  } from '@ant-design/icons';
import axios from 'axios';
import config from '../../utils/config';
import './index.css'
import { getLang, openErrorMsg, openSuccessMsg } from '../../utils/messageUtils';


const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const { Password } = Input
class ResetPasswordForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            isSecond: true,
            secondTime: 60,
            phone: '',
            captchaKey: ''
        }
    }

    handleCountDown = (seconds) => {
        let second = seconds;
        this.setState({isSecond: false, secondTime:second})
        const countDown = () => {
            if (second > 0) {
            second--;
            this.setState({ secondTime:second})
            }
            if (second === 0) {
            this.setState({isSecond: true})
            second = seconds;
            clearTimeout(second); // 清除计时器
            return;
            }
            setTimeout(countDown, 1000);
        };
        setTimeout(countDown, 1000);
    };

    /**
     * 获取手机验证码
     */
     getPhoneCaptcha = () =>{
        const params = {internationalTelCode:'+86', account: this.state.phone, lang: getLang()}
        axios
        .get(`${config.API_HOST}/oauth/password/mobile/send-captcha`,{ params })
        .then((result) => {
            console.log('result--',result);
            const { data } = result;
            if(data.success){
                this.handleCountDown(60);
                this.setState({ captchaKey: data.data })
                openSuccessMsg(this.props.t('tips', { defaultValue: '提示' }), data.message);
            }else{
                openErrorMsg(this.props.t('tips', { defaultValue: '提示' }), data.message);
            }
        })
        .catch((err) => {
            console.log(err);
        });
    }


    onFinish = async (values) => {
       console.log('valus==',values);
       const params = {
        account: values.account,
        captcha: values.captcha,
        password: values.password,
        rePassword: values.rePassword,
        captchaKey: this.state.captchaKey,
        lang: getLang(),
       }
       axios
       .post(`${config.API_HOST}/oauth/password/mobile/modify`, params, {
            headers: {
                "Content-type": "application/x-www-form-urlencoded"
            }
        })
        .then((result) => {
            const { data } = result;
            if(data.success){
                this.props.onNext();
            }else{
                openErrorMsg(this.props.t('tips', { defaultValue: '提示' }), data.message);
            }
            
        })
        .catch((err) => {
            console.log(err);
        });
       
    }

    toHome = () =>{
        this.props.history.push('/home');
    }

    phoneChang = (e) =>{
        this.setState({ phone: e.target.value })
    }

    render() {
        console.log('data:',this.state.captchaImg);
        return (
            <Form
                className='check-form'
                {...layout}
                name="basic"
                size='large'
                ref={this.formRef}
                onFinish={this.onFinish.bind(this)}
            >
                <Form.Item  name="account" rules={[{ required: true, message: this.props.t('phoneEmailPlaceholder', { defaultValue: '请输入手机号/邮箱' }) }]}>
                    <Input onChange={this.phoneChang} prefix={<PhoneOutlined />} placeholder={ this.props.t('phoneEmailPlaceholder', { defaultValue: '请输入手机号/邮箱' }) } />
                </Form.Item>
                <Form.Item  name="password" rules={[{ required: true, message: this.props.t('oldPassword', { defaultValue: '请设置新密码' }) }]}>
                    <Password visibilityToggle={false} prefix={<UserOutlined />} placeholder={ this.props.t('oldPassword', { defaultValue: '请设置新密码' }) } />
                </Form.Item>
                <Form.Item  name="rePassword" rules={[{ required: true, message: this.props.t('newPassword', { defaultValue: '请输入再次新密码' }) }]}>
                    <Password visibilityToggle={false} prefix={<UserOutlined />} placeholder={ this.props.t('newPassword', { defaultValue: '请输入再次新密码' }) } />
                </Form.Item>
                <Form.Item name='captcha' rules={[{ required: true, message: this.props.t('captchaPlaceholder', { defaultValue: '请输入验证码' }) }]} >
                    <Input prefix={<EditOutlined />} placeholder={ this.props.t('captchaPlaceholder', { defaultValue: '请输入验证码' })  } suffix={
                    <Button type='link' disabled={!this.state.isSecond}  onClick={this.getPhoneCaptcha.bind(this)}>
                        {this.state.isSecond
                        ? this.props.t('getcCptcha', { defaultValue: '获取验证码' })
                        : `${this.state.secondTime}S`}</Button>
                    } />
                </Form.Item>

                <div>
                    <Form.Item className="button-form-item">
                        <Button className="password-form-button" onClick={this.toHome}>{ this.props.t('cancel', { defaultValue: '取消' }) }</Button>
                        <Button type="primary" htmlType="submit" className="password-form-button">{ this.props.t('next', { defaultValue: '下一步' }) }</Button>
                    </Form.Item>
                </div>  
            </Form>
            )
    }
}

export default ResetPasswordForm = withTranslation()(ResetPasswordForm);